import { Button } from '@farol-ds/react'
import { useContext } from 'react'

import { TopbarContext } from '../../context'

interface TopbarJusIAFreemiumButtonProps {
  onClick?: (e: React.MouseEvent) => void
}

export const TopbarJusIAFreemiumButton = ({ onClick }: TopbarJusIAFreemiumButtonProps) => {
  const { user, flags } = useContext(TopbarContext)

  if (
    !user?.hasJusIAFeatures ||
    user?.hasPaidPlan ||
    user?.boxProfileInfo?.linkedAccount ||
    !flags?.hasInteractedWithJusIAAlert
  ) {
    return null
  }

  return (
    <Button kind="tertiary" size="md" asChild>
      <a
        href={`https://ia.jusbrasil.com.br/conversa?fromComponent=topbar-freemium-jus-ia-cta`}
        target="_blank"
        data-testid="topbar-freemium-jus-ia-cta-link"
        onClick={onClick}
        rel="noreferrer"
      >
        Jus IA
      </a>
    </Button>
  )
}
